export default __webpack_public_path__ + "static/media/findclass3.22a32512.png";